import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//import AddTeacherForm from '../register/AddTeacherForm';
import AddMentor from './Components/AddMentor';
import Student from '../../../pages/User';
import TeacherTable from './TeacherTable';
import { Divider } from '@mui/material';
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component={"div"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const Mentors = () => {
    const access = JSON.parse(localStorage.getItem('detailObject'))
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant='h3' mb={3} >Manage Mentors</Typography>
            <Divider />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>

                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ width: '100%', }}>
                    <Tab label="All Mentors" sx={{ width: '100%' }} {...a11yProps(0)} />
                    {(access?.access?.includes('Add Mentors') || access?.access.includes('all')) && (<Tab label="Add Mentors" sx={{ width: '100%' }} {...a11yProps(1)} />)}
                    {/* <Tab label="Item Three" sx={{ width: '100%' }} {...a11yProps(2)} /> */}
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <TeacherTable />
            </TabPanel>
            {(access?.access?.includes('Add Mentors') || access?.access.includes('all')) && (<TabPanel value={value} index={1}>
                <AddMentor/>
            </TabPanel>)}

        </Box>
    );
}

export default Mentors